const theme = {
  name: "DevelRx",
primary: "#E66A75",
  secondary: "#E66A75",
  tertiary: "#E66A75",
  cta: "#E66A75",
  shade: {
    "100": "#ffffff",
    "90": "#f5f7fb",
    "80": "#e9edf5",
    "70": "#dbe1eb",
    "60": "#cad1dd",
    "50": "#b6becb",
    "40": "#9ea7b2",
    "30": "#828a93",
    "20": "#61676e",
    "10": "#3c4044",
    "0": "#16181a",
  },
  hue: {
    "100": "#FFFCFC",
    "90": "#FCF5F5",
    "80": "#F6E6E6",
    "70": "#EDCDCE",
    "60": "#E1ACAD",
    "50": "#D18788",
    "40": "#BC6365",
    "30": "#A14648",
    "20": "#803031",
    "10": "#5B1F20",
    "00": "#361112",
  },
  maxWidth: "1180px",
  breakpoints: {
    xs: "400px",
    sm: "600px",
    md: "900px",
    lg: "1200px",
    xl: "1600px",
  },
  shadow: {
    long: "0px 4px 20px rgba(0, 0, 0, 0.1);",
  },
  border: {
    default: "2px",
  },
  radius: {
    default: "4px",
    large: "8px",
  },
  opacity: {
    default: 0.4,
  },
}

export default theme
